export const EMBED_SIZES = {
  small: { width: 560, height: 315, label: 'Small (560x315)' },
  medium: { width: 640, height: 360, label: 'Medium (640x360)' },
  large: { width: 854, height: 480, label: 'Large (854x480)' },
  xlarge: { width: 1280, height: 720, label: 'Extra Large (1280x720)' },
} as const;

export type EmbedSize = keyof typeof EMBED_SIZES;

/** URL identity used in published links: base-converted media ID or customer Reference ID. */
export const PUBLISH_LINK_FORMATS = ['mediaId', 'refId'] as const;
export type PublishLinkFormat = typeof PUBLISH_LINK_FORMATS[number];

/**
 * Parse width/height strings to numbers.
 * Used when user enters custom dimensions.
 */
export function parseSize(widthStr: string, heightStr: string): { width: number; height: number } {
  const width = parseInt(widthStr, 10);
  const height = parseInt(heightStr, 10);
  return {
    width: isNaN(width) ? 640 : width,
    height: isNaN(height) ? 360 : height,
  };
}
